const complete = {
  name: 'COMPLETE',
  dotColor: '#85ec55'
}

const partial = {
  name: 'PARTIAL',
  dotColor: '#edc153'
}

const missing = {
  name: 'MISSING',
  dotColor: '#ef5454'
}

export default {
  complete,
  partial,
  missing
}
